import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children:[],
    beforeEnter:(to, from, next)=>{
      //数据字典
      fetch(`${process.env.VUE_APP_BASE_API}/BaseDataDictionary/GetAllDatas`,{ 
        method: 'GET',
        headers: {  
          'Accept':'application/json',
          'Content-Type': 'application/json',  
        }
      })
      .then(res=>res.text())
      .then(res => {
        const jsonObject = JSON.parse(res);
        if(jsonObject.Code==200){
          window.localStorage.setItem("DataDictionary",JSON.stringify(jsonObject.Data));
        }
        next()
      });
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginPage.vue')
  },
  {
    path: '/menuList',
    name: 'menuList',
    component: () => import('../components/BaseInfo/MenuList.vue')
  },
  {
    path: '/dictionaryClassifyList',
    name: 'dictionaryClassifyList',
    component: () => import('../components/BaseInfo/DictionaryClassifyList.vue')
  },
  {
    path: '/dictionaryList',
    name: 'dictionaryList',
    component: () => import('../components/BaseInfo/DictionaryList.vue')
  },
  {
    path: '/baseUserList',
    name: 'baseUserList',
    component: () => import('../components/BaseInfo/BaseUserList.vue')
  },
  {
    path: '/baseRoleList',
    name: 'baseRoleList',
    component: () => import('../components/BaseInfo/BaseRoleList.vue')
  },
  {
    path: '/listPageMasterPage',
    name: 'istPageMasterPage',
    component: () => import('../components/BaseInfo/ListPageMasterPage.vue')
  },
  {
    path: '/customerLongList',
    name: 'customerLongList',
    component: () => import('../components/Customer/CustomerLongList.vue')
  },
  {
    path: '/customerShortList',
    name: 'customerShortList',
    component: () => import('../components/Customer/CustomerShortList.vue')
  },
  {
    path: '/customerTrackingRecordList',
    name: 'customerTrackingRecordList',
    component: () => import('../components/Customer/CustomerTrackingRecordList.vue')
  },
  {
    path: '/customerContactList',
    name: 'customerContactList',
    component: () => import('../components/Customer/CustomerContactList.vue')
  },
  {
    path: '/customerOfficialList',
    name: 'customerOfficialList',
    component: () => import('../components/Customer/CustomerOfficialList.vue')
  },
  {
    path: '/customerPriceOfferList',
    name: 'customerPriceOfferList',
    component: () => import('../components/Customer/CustomerPriceOfferList.vue')
  },
  {
    path: '/customerProductInfoList',
    name: 'customerProductInfoList',
    component: () => import('../components/Customer/CustomerProductInfoList.vue')
  },
  {
    path: '/companyBaseInfoList',
    name: 'companyBaseInfoList',
    component: () => import('../components/Company/CompanyBaseInfoList.vue')
  },
  {
    path: '/companyReceivingAccountList',
    name: 'companyReceivingAccountList',
    component: () => import('../components/Company/CompanyReceivingAccountList.vue')
  },
  {
    path: '/companyInvoiceList',
    name: 'companyInvoiceList',
    component: () => import('../components/Company/CompanyInvoiceList.vue')
  },
  {
    path: '/companySalePriceList',
    name: 'companySalePriceList',
    component: () => import('../components/Company/CompanySalePriceList.vue')
  },
  {
    path: '/companySalePriceList2',
    name: 'companySalePriceList2',
    component: () => import('../components/Company/CompanySalePriceList2.vue')
  },
  {
    path:'/companyProductDetailList',
    name:'companyProductDetailList',
    component:()=>import('../components/Company/CompanyProductDetailList.vue')
  },
  {
    path:'/plm/projectManage',
    name:'projectManage',
    component:()=>import('../components/PLM/ProjectManage/ProjectMngList.vue')
  },
  {
    path:'/oe/LogisticsList',
    name:'LogisticsList',
    component:()=>import('../components/OE/BaseData/LogisticsList.vue')
  },
  {
    path:'/oe/accountsReceivable',
    name:'AccountsReceivable',
    component:()=>import('../components/OE/BaseData/AccountsReceivable.vue')
  },
  {
    path:'/oe/minPackage',
    name:'MinPackage',
    component:()=>import('../components/OE/BaseData/MinPackage.vue')
  },
  {
    path:'/oe/predictionOrder',
    name:'PredictionOrder',
    component:()=>import('../components/OE/PreOrderDemand/PredictionOrder.vue')
  },
  {
    path:'/oe/orderDeliverDateInfo',
    name:'OrderDeliverDateInfo',
    component:()=>import('../components/OE/PreOrderDemand/OrderDeliverDateInfo.vue')
  },
  {
    path:'/oe/deliveryPlan',
    name:'DeliveryPlan',
    component:()=>import('../components/OE/PreOrderDemand/DeliveryPlanIndex.vue')
  },
  {
    path:'/oe/DeliveryPlanPane1', //发货计划
    name:'DeliveryPlanPane1',
    component:()=>import('../components/OE/PreOrderDemand/component/DeliveryPlanPane1.vue')
  },
  {
    path:'/oe/DeliveryPlanPane2', //发货计划汇总
    name:'DeliveryPlanPane2',
    component:()=>import('../components/OE/PreOrderDemand/component/DeliveryPlanPane2.vue')
  },
  {
    path:'/customerOrderList',
    name:'customerOrderList',
    component:()=>import('../components/OrderManagement/CustomerOrderList.vue')
  },
  {
    path:'/customerOrderOutSideList',
    name:'customerOrderOutSideList',
    component:()=>import('../components/OrderManagement/CustomerOrderOutSideList.vue')
  },
  {
    path:'/customerProformaInvoiceList',
    name:'customerProformaInvoiceList',
    component:()=>import('../components/OrderManagement/CustomerProformaInvoiceList.vue')
  },
  {
    path:'/customerDeliveryPlanList',
    name:'customerDeliveryPlanList',
    component:()=>import('../components/OrderManagement/CustomerDeliveryPlanList.vue')
  },
  {
    path:'/customerCollectionPlanList',
    name:'customerCollectionPlanList',
    component:()=>import('../components/OrderManagement/CustomerCollectionPlanList.vue')
  },
  {
    path:'/companyPackagingMaterialList',
    name:'companyPackagingMaterialList',
    component:()=>import('../components/Company/CompanyPackagingMaterialList.vue')
  },
  {
    path:'/customerPreparePackNoteList',
    name:'customerPreparePackNoteList',
    component:()=>import('../components/OrderManagement/CustomerPreparePackNoteList.vue')
  },
  {
    path:'/customerPackNoteHeadList',
    name:'customerPackNoteHeadList',
    component:()=>import('../components/OrderManagement/CustomerPackNoteHeadList.vue')
  },
  {
    path:'/saleOrderSearchU9',
    name:'saleOrderSearchU9',
    component:()=>import('../components/OrderManagement/SaleOrderSearchU9.vue')
  },
  {
    path:'/customerPpapList',
    name:'customerPpapList',
    component:()=>import('../components/OrderManagement/CustomerPpapList.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
